/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateProfileEntryDataSchema = z.object({
	id: z.string(),
	contents: z.string(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type CandidateProfileEntryDataSchema = z.infer<typeof candidateProfileEntryDataSchema>
